import React, { FC } from 'react';
import { Container, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
}));

const HeroUnit: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.heroContent}>
      <Container maxWidth="sm">
        <Typography
          component="h1"
          variant="h3"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          好奇心ドリブン開発
        </Typography>
        <Typography variant="h6" align="center" color="textSecondary" paragraph>
          自分が興味を持ったこと、やってみたいと思ったものをひたすら作って公開していく場所です。
        </Typography>
      </Container>
    </div>
  );
};

export default HeroUnit;
